import React, { useEffect, useRef } from 'react';

export function useIndeterminateCheckbox(indeterminate: boolean): React.RefObject<HTMLInputElement | null> {
    const ref = useRef<HTMLInputElement>(null);

    useEffect(() => {
        const checkbox = ref.current;

        if (checkbox) {
            checkbox.indeterminate = indeterminate;
        }
    }, [indeterminate]);

    return ref;
}
